module.exports = __webpack_public_path__ + "media/images/sp/stores/suns/magazine/point03_04_spectacular_spot-cb3f21505d5f63a272b897954006c65e.jpg";